import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import i18n from 'i18next';
import LoadingOverlay from '../common/LoadingOverlay';

import { tokenVerify, tokenVerifyFail } from "../../actions";

import tokenWorker from "../../api/workers/token.worker";
import WebWorker from "../../api/workers/workerSetup";
import { getApiBaseUrl } from "../../api/axiosInstance";

import App from "./../../containers/App/App";
import Auth from "../../components/Auth/Auth";

require('moment/locale/fi');
require('moment/locale/en-gb');

function Root() {

	const history = useHistory();
	const dispatch = useDispatch();
	const { isAuthenticated, authenticating, userID, loggedOut } = useSelector(state => state.auth);

	// change moment locale to current selected language
	moment.locale(i18n.language === 'en' ? 'en-gb' : i18n.language);

	// Authenticate on component mount
	useEffect(() => {
		if (localStorage.getItem("token")) {
			const payload = { token: localStorage.getItem("token"), userID };
			dispatch(tokenVerify(payload));
		} else {
			dispatch(tokenVerifyFail());
			history.push("/");
		}
	}, [dispatch, userID, history]);


	// Set up token worker
	useEffect(() => {

		let tokenInterval, worker;
		worker = new WebWorker(tokenWorker);

		if (isAuthenticated) {
			tokenInterval = setInterval(() => {
				if (!localStorage.getItem("token")) {
					dispatch(tokenVerifyFail());
					history.push("/");
				}
				worker.postMessage({
					token: localStorage.getItem("token"),
					url: getApiBaseUrl() + "users/refresh"
				});
				worker.addEventListener("message", e => {
					const responseData = JSON.parse(e.data);
					if (responseData.token) {
						localStorage.setItem("token", responseData.token);
					} else {
						clearInterval(tokenInterval);
						dispatch(tokenVerifyFail());
						history.push("/");
					}
				});
			}, 20000);
		}

		// Clean up function
		return () => {
			clearInterval(tokenInterval);
			worker.terminate();
		};
	}, [isAuthenticated, history, dispatch]);

	return (
		<React.Fragment>
			{authenticating && !loggedOut && !userID ? (
				<div style={{ position: 'relative', height: '100%' }}>
					<LoadingOverlay variant="dark" />
				</div>
			) : isAuthenticated ? (
				<App />
			) : (
				<Auth />
			)}
		</React.Fragment>
	);
}

export default Root;
